<template>
  <form-section :title="title">
    <template slot="controls">
      <content-actions
        v-model="value"
        :channel="$route.query.channel"
        apply-template-enabled
        copy-enabled
        :model="model"
      />
      <slot name="selected-template-info"></slot>
    </template>
    <el-row>
      <el-col :lg="10" :xl="8">
        <form-item
          :label="$t('CampaignForm_Facebook_Field_Title')"
          prop="title"
        >
          <snippet-input
            v-model="value.facebook.title"
            :snippets="false"
            :optimove="isOptimove"
            :salesforce="isSalesforce"
            data-qa="facebook-subject-input"
          />
        </form-item>
        <form-item
          :label="$t('CampaignForm_Facebook_Field_Subtitle')"
          prop="subtitle"
        >
          <snippet-input
            type="textarea"
            v-model="value.facebook.subtitle"
            :snippets="false"
            :optimove="isOptimove"
            :salesforce="isSalesforce"
            data-qa="facebook-message-input"
          />
        </form-item>
        <form-item
          prop="image_url"
          :label="$t('CampaignForm_Facebook_Field_Image')"
        >
          <campaign-image-upload
            :value="value.facebook.image_url"
            :file.sync="value.facebook.image_url"
            :message-type="channelTypes.facebook"
            accepts=".gif,.jpg,.jpeg,.png"
            size="small"
          />
        </form-item>
        <form-item :label="$t('CampaignForm_Facebook_Field_Url')" prop="url">
          <el-input
            v-model="value.facebook.default_action.url"
            data-qa="facebook-url-input"
          />
        </form-item>
      </el-col>
      <el-col :lg="14" :xl="16" class="preview">
        <facebook-message-preview :message="value.facebook" />
      </el-col>
    </el-row>
  </form-section>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import FormItem from '@/common/components/form/FormItem'
import FacebookMessagePreview from '@/common/components/facebook/FacebookMessagePreview'
import SnippetInput from '@/modules/campaign-manage/components/SnippetInput'
import { campaignTriggerTypes } from '@/modules/campaign-manage/enum/CampaignTriggerTypesEnum'
import CampaignImageUpload from '@/modules/campaign-manage/components/content/CampaignImageUpload'
import { channelTypes } from '@/modules/campaign-manage/enum/Labels'
import ContentActions from '@/modules/campaign-manage/components/ContentActions'
export default {
  name: 'Facebook',
  components: {
    ContentActions,
    CampaignImageUpload,
    SnippetInput,
    FacebookMessagePreview,
    FormItem,
    FormSection
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    model: {
      type: Object,
      required: true
    },
    title: {
      required: true
    }
  },
  data() {
    return {
      channelTypes
    }
  },
  computed: {
    isOptimove() {
      return this.model.trigger === campaignTriggerTypes.TRIGGER_OPTIMOVE
    },
    isSalesforce() {
      return this.model.trigger === campaignTriggerTypes.TRIGGER_SALESFORCE
    }
  }
}
</script>

<style scoped>
.preview {
  padding-top: 30px;
  background-color: #f8fafc;
  border-radius: 4px;
  min-height: 505px;
  display: flex;
  justify-content: center;
  align-items: baseline;
}
>>> .el-upload {
  width: 100% !important;
}
>>> .container {
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/content/channels/Facebook.vue